import SweetScroll from "sweet-scroll"

export default class ScrollTop {
  /**
  ** 実行
  ** @constructor
  **/     
  constructor() {
    this.getParam()
    this.init()
  }

  /**
  ** 各種要素を取得している
  ** @getParam
  **/    
  getParam () {
    this.el = document.querySelector(`[data-module='top-scroll']`)
  }

  /**
  ** オブジェクトを初期化
  ** @init
  **/
  init () {
    this.clickEvent()
    this.showEvent()
  }

   /**
   ** トップへ戻るボタンをクリックしSweetScrollを実行するオブジェクト
   ** @clickEvent
   **/   
    clickEvent () {
      const sweetScroll = new SweetScroll({
        trigger: "[data-scroll]",
        easing: "easeInOutQuad",
      })  
    }

  /**
  ** スクロール量によってクラスをトグル / フッターが見えた段階でクラスをトグル
  ** @showEvent
  **/     

  showEvent () {

    let ticking = false

    function scrollEvent () {
      const
        scrollAmount = window.pageYOffset,
        footerElem =  document.querySelector(`[data-module='footer-height']`),
        footerHeight = footerElem.clientHeight,
        foooterOffsetY = footerElem.getBoundingClientRect().top,    
        screenHeight = window.innerHeight,
        t_position = foooterOffsetY - screenHeight,        
        fixAmount = 100,
        elem = document.querySelector(`[data-module='top-scroll']`),
        toggle = 'is-show'

        if (!ticking) {
          requestAnimationFrame(function() {
            ticking = false;
            if(scrollAmount > fixAmount) {
              elem.classList.add(toggle)
            } else {
              elem.classList.remove(toggle)
            }

            if(-screenHeight<=(t_position　+ footerHeight) && t_position<0) {
              elem.classList.add('is-fixed')

            } else {
              elem.classList.remove('is-fixed')
      
            }
          });
          ticking = true;          
      } 
    }
    document.addEventListener('scroll', scrollEvent, {passive: true});
  }
}